export interface ApplicationContext {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: string;
  reportingGroupId?: string;
  reportingGroupName?: string;
  vertexCompanyCode?: string;
  workpaperPassword?:string;
  currentUser?: string;
  userProfile?: {
    name?: string;
    employeeID?: string;
    [key: string]: any; 
  };
}

export interface PermissionContext {
  canApprovePreparation: boolean;
  canApproveReview: boolean;
  canApproveSignerReview: boolean;
  canApproveClientApproval: boolean;
  canApproveEFiling: boolean;
  canApproveConfirmationReview: boolean;
}